import React, {  useState } from 'react'
import ModalHomeBeneficiary from '../containers/homeContainers/modalHomeBeneficiary'
import Avatar from './avatar'

interface props {
  nom? : string
  num? : string
  photo: any
  genre ?: string
  index: any
  person: object
  setIndexBeneficiairy: any
  indexBeneficiary: any
  item:any
  afficheName?: boolean
  prefix : string
  lastName? : string
  isClickable?: boolean
  styleCss?: string

}

const BenificePerson: React.FC<props> = ({
  nom,
  num,
  photo,
  genre,
  setIndexBeneficiairy,
  index,
  person,
  indexBeneficiary,
  item,
  afficheName,
  prefix,
  lastName,
  isClickable=true,
  styleCss='w-[50px] h-[50px]'
}) => {
  const [isOpenModal, setIsopenModal] = useState(false)

  const openModalBeneficiaryPerson = (person: any) => {
    setIsopenModal(true)
  }
  const closeModalBeneficiaryPerson = () => {
    setIsopenModal(false)
  }

  return (
    <>
      <div
          // ${isClickable? ' cursor-pointer': ''} 
        className={`
        flex items-center gap-[24px]  cursor-default`}
        // onClick={() => {
          
        //   setIndexBeneficiairy(index)
        //   openModalBeneficiaryPerson(person)
        // }}
      >
        <Avatar 
        genre={genre}
        avatar={photo} 
        name={nom}
        num={num} 
        afficheName={afficheName}
        lastName={lastName}
        styleCss={styleCss} 
        
        />
       
      </div>
      {isClickable && 
      <ModalHomeBeneficiary
        nom={`${item?.personalInfo?.gender === 'male' ? 'M.' : 'Mme'} ${nom}`}
        num={num}
        photo={item.avatar ? item.avatar : item.personalInfo.gender}

        // photo={photo}
        index={index}
        indexBeneficiary={indexBeneficiary}
        isOpen={isOpenModal}
        closeModal={closeModalBeneficiaryPerson}
        person={person}
        prefix={prefix}
      />}
    </>
  )
}
export default BenificePerson
